export enum FilterPlatformEnum {
  All = 'all',
  Web = 'web',
  IOS = 'ios',
  Android = 'android',
  Apps = 'apps'
}
